// extracted by mini-css-extract-plugin
module.exports = {"container":"TotalHours_container__6jlTC","text":"TotalHours_text__1zzIJ"};